import React from 'react';
import classNames from 'classnames';
import './worker-state-label-badge.scss';
import Icons from 'assets/images/Icons';
import iconsIndex from 'assets/images/Icons/iconsIndex';

const WorkerStateLabelBadge = ({ state }: { state: string }) => {
  const states: Record<string, {display: string, icon: keyof typeof iconsIndex}> = {
    dis: {
      display: 'Disabled',
      icon: 'Exclamation',
    },
    low: {
      display: 'Low',
      icon: 'Down',
    },
    off: {
      display: 'Offline',
      icon: 'Power',
    },
    ok: {
      display: 'OK',
      icon: 'Check',
    },
  };

  const { display, icon } = states[state];

  return (
    <div className={classNames({
      label: true,
      [state]: true,
      'state-label': true,
    })}>
      <Icons name={icon} />{display}
    </div>
  );
};

export default WorkerStateLabelBadge;